<div class="container-fluid">
  <div
    [ngClass]="{
      'height-700': isLoaderComponent,
      'height-500': !isLoaderComponent
    }"
    class="row d-flex justify-content-center padding"
  >
    <div class="micontainer text-center" [class.loader]="isLoaderComponent">
      <div
        *ngIf="!isLoaderComponent"
        class="w-100 Tipografia-Desktop-h5 d-flex justify-content-center"
      >
        <div class="mititulo2">
          <h3 class="extraText" [innerHTML]="extraText"></h3>
        </div>
      </div>
      @if(isWebm(image)) {
      <div class="row justify-content-center">
        <app-webm-player
          src="./assets/img/loader.webm"
          alt="Seguro de moto precio"
          width="50%"
          height="auto"
          cssClass="video-background"
        />
      </div>
      } @else {
      <div class="w-100">
        <img
          [src]="image"
          [ngClass]="{ 'gif-img': isGif(image), 'png-img': isPng(image) }"
          class="img d-block d-sm-none mx-auto"
          alt="Image"
        />
      </div>
      }

      <div
        *ngIf="!isLoaderComponent"
        class="w-100 Tipografia-Desktop-h5 d-flex justify-content-center"
      >
        <div class="mititulo2">
          <h1>{{ title }}</h1>
          <h5 class="mititulo mt-2" [innerHTML]="subtitle"></h5>
        </div>
      </div>
      @if(!isWebm(image)) {
      <img
        [src]="image"
        [ngClass]="getImageClass(image)"
        class="img d-none d-sm-block mx-auto"
        alt="Image"
      />
      }

      <div
        *ngIf="isLoaderComponent"
        class="w-100 Tipografia-Desktop-h5 d-flex justify-content-center mt-3"
      >
        <div class="mititulo2">
          {{ title }}
          <h5 class="mititulo mt-2">{{ subtitle }}</h5>
        </div>
      </div>

      <div
        class="button-container"
        [ngClass]="{ 'btn-multiple': buttons.length > 1 }"
        style="width: 100%"
      >
        <button
          *ngFor="let button of buttons; trackBy: trackByFn"
          class="mybuttom btn mx-3"
          [ngClass]="getButtonClass(button)"
          (click)="button?.action()"
        >
          {{ button.text }}
        </button>
      </div>
    </div>
  </div>
</div>
